<template>
  <v-card :min-height="minHeight + 'px'" :color="corFundo" class="d-flex flex-column borda-arredondada">
    <v-card-title>
      <span class="title font-weight-bold titulo-ajustavel" :style="'color:' + corTitulo + ' !important; '">
        <v-icon :color="corTitulo" large left>{{ icon }}</v-icon>{{getTitle}} 
      </span>
    </v-card-title>
    <v-card-text class="subtitle-1 font-weight-light flex-grow-1 d-flex flex-column">
      <div class="text-center">
        <v-progress-circular
            :rotate="180"
            :size="100"
            :width="15"
            indeterminate
            :color="loadingColor"
            v-show="loading"
        >
        </v-progress-circular>
      </div>
      <div v-show="!loading" class="conteudo-branco borda-arredondada"
        :style="{ minHeight: (minHeight + (minHeight*0.125)) + 'px' }">
        <slot></slot>
      </div>
      <slot name="footer"/>
    </v-card-text>
  </v-card>
</template>

<script>
import PainelCardBar from "./PainelCardBar";
export default {
  name: "PainelCard",
  components: {PainelCardBar},
  props: ['icon', 'title', 'corTitulo', 'corFundo', 'loading', 'minHeight'],
  computed: {
    loadingColor() {
      return this.$utils.colors.pSBC(0.23, "#4460C2");
    },
    getTitle() {
      return this?.title ? this.title : '';
    }
  },
}
</script>
<style scoped lang="scss">
  .borda-arredondada {
    -webkit-border-radius: 1em !important;
    -moz-border-radius: 1em !important;
    border-radius: 1em !important;
  }
  .conteudo-branco {
    background-color: white;
    padding: 1em;
  }
  .titulo-ajustavel {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
  }
</style>